<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1" v-if="!add_show">
                巡课设置
            </div>
            <div style="width:105px" v-if="add_show"></div>
            <el-button type="primary" size="small" @click='add()' v-if="!add_show">添加巡课目标</el-button>
        </div>
        <div class="table" v-if="!add_show">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column type="index" label="序号" width="50" align="center">
				</el-table-column>
                <el-table-column prop="a" label="巡课目标" align="center">
                </el-table-column>
                <el-table-column prop="b" label="巡课日期" align="center">
                </el-table-column>
                <el-table-column prop="c" label="巡课指标" align="center">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="得分说明" width="150">
                    <template slot-scope="scope" style="position:relative;">
                        <el-button type="text" size="small" @click="look(scope.row)">查看</el-button>
                        <div v-if="scope.row.show" class="look" :class="{'last-look':scope.row.id===tableData[tableData.length-1].id}">
                            <p>班级卫生：主要巡查桌椅摆放、地上垃圾；满分5分</p>
                            <p>学习氛围：全员认真听讲则有5分</p>
                            <p>课件配套：有配套5分，无配套0分</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="d" label="备注" align="center">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="巡课报告" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                
            </el-table>
            <div class="pagination" v-if="totalPage>0">
                <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
            </div>
        </div>

        <!-- 添加巡课目标 -->
        <div class="add-main" v-if="add_show">
            <ul class="add-ul">
                <li class="add-li">
                    <span>巡课目标</span>
                    <el-input style="width:524px" type="text" v-model="mb" placeholder="请输入"></el-input>
                </li>
                <li class="add-li">
                    <span>负责人</span>
                    <el-select style="width:302px" v-model="fzr" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in fzrList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </li>
                <li class="add-li">
                    <span>巡课日期</span>
					<el-date-picker v-model="date" type="daterange" style="width: 302px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
					</el-date-picker>
                </li>

                <div class="main-title">
                    <img src="./imgs/icon_01.svg" alt="">
                    <p>指标管理</p>
                </div>
                <div class="bqs">
                    <div class="bq" :class="{'bq-blue':bq.check}" v-for="(bq,i) in bqList" :key="bq.title+i">
                        <div>
                            <span>{{bq.title}}</span><span>{{bq.check?'x':'+'}}</span>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <el-button style="width:110px" size="small">取消</el-button>
                    <el-button type="primary" size="small" style="margin-left:20px;width:110px">确定</el-button>
                </div>

                <div class="main-title">
                    <img src="./imgs/icon_02.svg" alt="">
                    <p>得分说明</p>
                </div>
                <li class="add-li">
                    <span>学习氛围</span>
                    <el-input style="width:524px" type="text" v-model="fw" placeholder="请输入"></el-input>
                </li>
                <li class="add-li">
                    <span>课件配套情况</span>
                    <el-input style="width:524px" type="text" v-model="pz" placeholder="请输入"></el-input>
                </li>
                <li class="add-li">
                    <span>教师授课态度</span>
                    <el-input style="width:524px" type="text" v-model="td" placeholder="请输入"></el-input>
                </li>
                <li class="add-li">
                    <span>学生听课情况</span>
                    <el-input style="width:524px" type="text" v-model="tk" placeholder="请输入"></el-input>
                </li>
                <div class="btn-box">
                    <el-button style="width:110px" size="small">取消</el-button>
                    <el-button type="primary" size="small" style="margin-left:20px;width:110px">确定</el-button>
                </div>

                <div class="main-title">
                    <img src="./imgs/icon_03.svg" alt="">
                    <p>备注</p>
                </div>
                <el-input style="margin-top:20px" type="textarea" resize="none" :rows="4" placeholder="请输入" v-model="textarea">
                </el-input>
                <div class="btn-box">
                    <el-button style="width:110px" size="small">取消</el-button>
                    <el-button type="primary" size="small" style="margin-left:20px;width:110px">保存</el-button>
                </div>
            </ul>
        </div>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [
                // {id:'1231',a:'教学加强月',b:'2021-11-01~2021-11-15',c:'班级卫生学习氛围课件配套情况教师授课态度学生听讲情况',d:'重点巡查课堂上老师的态度',show:false},
				// {id:'1231231321',a:'教学拓展月',b:'2021-11-01~2021-11-15',c:'班级卫生学习氛围课件配套情况教师授课态度学生听讲情况',d:'重点巡查课堂上老师的态度',show:false},
            ],
			list:[
				{title:'班级卫生',star:3},
				{title:'学习氛围',star:3},
				{title:'课件配套情况',star:3},
				{title:'教师授课态度',star:3},
                {title:'学生听课情况',star:3},
			],
            textarea:'本周李老师的课堂氛围很好，学生互动积极，但有部分学生有上课睡觉的行为，希望后面李老师可以加强对课上纪律的监管',
            add_show:false,
            mb:'',
            fzrList:[],
            fzr:'',
            date:'',
            bqList:[
                {title:'班级卫生',check:true},
                {title:'学习氛围',check:true},
                {title:'课件配套情况',check:true},
                {title:'教师授课态度',check:true},
                {title:'学生听课情况',check:true},
                {title:'自定义指标',check:false},
            ],
            fw:'',
            pz:'',
            td:'',
            tk:'',
            textarea:'',
		}
	},
	computed:{

	},
	watch: {

	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
			// console.log('学生分布详情',res)
		},
        toIndex(){
            if(this.add_show){
                this.add_show=false;
            }else{
                this.$emit('to-index');
            }
        },
		save(){},
        add(){
            this.add_show=true;
        },
        edit(item){},
        del(item){},
        look(item){
            this.tableData.forEach(e=>{
                if(item.id!==e.id){
                    e.show=false;
                }
            })
            item.show=!item.show;
        },
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
            text-align: center;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	
	.look{
        position: absolute;
        top: 60px;
        right: -100px;
        width: 346px;
        height: 112px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #d9dee8;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
        z-index: 10000;
        p{
            width: 100%;
            margin: 10px 12px 0;
            font-size: 14px;
            line-height: 26px;
            text-align: left;
            color: #666;
        }
    }
    .last-look{
        top: -80px;
        right: -100px;
    }
    .add-main{
        width: 100%;
        .main-title{
			display: flex;
			align-items: center;
            margin-top: 30px;
            img{
                width: 17px;
            }
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
        .add-ul{
            .add-li{
                display: flex;
                margin-top: 20px;
                span{
                    width: 110px;
                    text-align: right;
                    line-height: 42px;
                    font-size: 14px;
                    color: #888;
                    margin-right: 20px;
                }
            }
        }
        .bqs{
            width: 100%;
            .bq{
                width: calc(20% - 20px);
                margin-right: 20px;
                margin-top: 20px;
                height: 32px;
                border-radius: 16px;
                background: #fff;
                border: 1px solid #b2b2b2;
                font-size: 14px;
                color: #666;
                display: inline-block;
                div{
                    width: 100%;
                    height: 100%;
                    padding: 0 15px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
            .bq-blue{
                color: #4991e1;
                border: 1px solid #4991e1;
            }
        }
        .btn-box{
            width: 100%;
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }
}
</style>